'use client';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { ArrowArrowRight } from '@s7/icons';
import { Stack, Group, Flex } from '@s7/layout';
import { packSX } from '@s7/styles';
import { TextField, Checkbox, Button, Typography } from '@s7/ui';
import { textFieldStyles, blockSX } from './FooterSubscriptions.styles.js';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var FooterSubscriptions = function(props) {
    var agreed = props.agreed, onAgreementChange = props.onAgreementChange, title = props.title, agreement = props.agreement, buttonProps = props.buttonProps, onSubmit = props.onSubmit, textFieldRef = props.textFieldRef, textFieldProps = props.textFieldProps, checkboxProps = props.checkboxProps, others = _object_without_properties_loose(props, [
        "agreed",
        "onAgreementChange",
        "title",
        "agreement",
        "buttonProps",
        "onSubmit",
        "textFieldRef",
        "textFieldProps",
        "checkboxProps"
    ]);
    var Input = /*#__PURE__*/ jsx(TextField, _extends({
        ref: textFieldRef,
        placeholder: "E-mail",
        styles: textFieldStyles
    }, textFieldProps));
    var MainControls = agreement ? /*#__PURE__*/ jsxs(Stack, {
        breakpoints: {
            "md1.up": {
                spacing: 8,
                stretch: false
            }
        },
        spacing: 20,
        stretch: true,
        children: [
            Input,
            /*#__PURE__*/ jsx(Checkbox, _extends({
                wrapperProps: {
                    align: "start"
                },
                size: "xs1"
            }, checkboxProps, {
                checked: agreed,
                label: agreement,
                required: true,
                onChange: function(event) {
                    return onAgreementChange == null ? void 0 : onAgreementChange(event.target.checked);
                }
            }))
        ]
    }) : Input;
    var Controls = /*#__PURE__*/ jsxs(Group, {
        align: "start",
        spacing: 12,
        noWrap: true,
        children: [
            MainControls,
            /*#__PURE__*/ jsx(Button, _extends({
                leftSide: /*#__PURE__*/ jsx(ArrowArrowRight, {
                    size: 20
                }),
                title: "Подписаться",
                type: "submit",
                width: 72
            }, buttonProps, {
                disabled: !agreed,
                sx: [].concat([
                    {
                        height: 48
                    }
                ], packSX(buttonProps == null ? void 0 : buttonProps.sx))
            }))
        ]
    });
    return /*#__PURE__*/ jsxs(Flex, _extends({
        breakpoints: {
            "md1.up": {
                direction: "row",
                justify: "space-between"
            }
        },
        as: "form",
        direction: "column",
        spacing: 20,
        sx: blockSX,
        onSubmit: onSubmit
    }, others, {
        children: [
            /*#__PURE__*/ jsx(Typography, {
                breakpoints: {
                    "md1.up": {
                        size: "sm1",
                        weight: 600,
                        height: 24
                    }
                },
                sx: function(theme) {
                    var _obj;
                    return _obj = {}, _obj[theme.fn.up("md1")] = {
                        alignSelf: "center"
                    }, _obj;
                },
                height: 28,
                size: "md1",
                variant: "heading",
                preWrap: true,
                children: title
            }),
            Controls
        ]
    }));
};

export { FooterSubscriptions };
